import { CORE, gateway } from '../../api';


export function buscarMotivoBaixa() {
  return gateway.get(`${CORE}/motivo-baixa`);
}
